import { action, extendObservable } from 'mobx';
import { orderBy } from 'lodash';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import CreateCertificationItemDraftDialogService from './CreateCertificationItemDraftDialogService';

class CertificationTestRegisterItemListService {
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      items: [],
      certificationTestId: null,
      certificationTestCourse: null,
    });
  }

  init = action((certificationTestId) => {
    this.items = [];
    this.certificationTestId = certificationTestId;
    this.load();
  });

  load = action(() => {
    const fetchService = new FetchService();
    fetchService.fetch({ url: `/certification-test-course-ability/${this.certificationTestId}` }).then(() => {
      if (fetchService.data) {
        const certificationTestCourseAbility = fetchService.data;
        fetchService
          .fetch({
            url: `/courses/${certificationTestCourseAbility.course}`,
          })
          .then(() => {
            if (fetchService.data) {
              this.certificationTestCourse = fetchService.data;
            }
          });
      }
    });
    this.fetch
      .fetch({
        url: `/certification-test-course-ability/${this.certificationTestId}/items`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.items = orderBy(this.fetch.data, ['order'], ['asc']);
        } else {
          this.items = [];
          this.total = 0;
        }
      });
  });

  handleOrderChange = action((certificationTestItem, order) => {
    this.submit
      .fetch({
        url: `/certification-test-course-ability/${this.certificationTestId}/items/${certificationTestItem.item.id}`,
        method: 'put',
        body: {
          order,
        },
      })
      .then(() => {
        this.load();
      });
  });

  handleUnlinkItem = action((certificationTestItem) => {
    ConfirmationDialogService.show(
      'Delete Item',
      `You are about to delete the item "${certificationTestItem.item.text}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            url: `/certification-test-course-ability/${this.certificationTestId}/items/${certificationTestItem.item.id}`,
            method: 'delete',
          })
          .then(() => {
            NotificationService.addNotification('Item deleted', 'success');
            this.load();
          });
      }
    );
  });

  handleEdit = (certificationTestCourseAbilityItem) => {
    CreateCertificationItemDraftDialogService.handleShow({
      ...certificationTestCourseAbilityItem,
      certificationTestCourseAbility: {
        ...certificationTestCourseAbilityItem.certificationTestCourseAbility,
        course: this.certificationTestCourse,
      },
    });
  };
  handlePublish = (certificationTestCourseAbilityItem) => {
    ConfirmationDialogService.show(
      'Publish Draft Item',
      `Do you really want to publish the draft item with data "Course: ${this.certificationTestCourse.name}, Ability: ${certificationTestCourseAbilityItem.certificationTestCourseAbility.ability}, Grammar: ${certificationTestCourseAbilityItem.item.grammar.name}, Text: ${certificationTestCourseAbilityItem.item.text}"?`,
      () => {
        this.submit
          .fetch({
            method: 'patch',
            url: `/certification-test-course-ability/${certificationTestCourseAbilityItem.certificationTestCourseAbility.id}/items/${certificationTestCourseAbilityItem.item.id}/publish`,
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Draft item unpublished successfully', 'success');
              this.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification(this.submit.error || `Error to publish draft item`, 'error');
            }
          });
      }
    );
  };
  handleUnpublish = (certificationTestCourseAbilityItem) => {
    ConfirmationDialogService.show(
      'Unpublish Item',
      `Do you really want to unpublish the item with data "Course: ${this.certificationTestCourse.name}, Ability: ${certificationTestCourseAbilityItem.certificationTestCourseAbility.ability}, Grammar: ${certificationTestCourseAbilityItem.item.grammar.name}, Text: ${certificationTestCourseAbilityItem.item.text}"?`,
      () => {
        this.submit
          .fetch({
            method: 'patch',
            url: `/certification-test-course-ability/${certificationTestCourseAbilityItem.certificationTestCourseAbility.id}/items/${certificationTestCourseAbilityItem.item.id}/unpublish`,
          })
          .then(() => {
            if (this.submit.data) {
              NotificationService.addNotification('Draft item unpublished successfully', 'success');
              this.load();
            }
            if (this.submit.error) {
              NotificationService.addNotification(this.submit.error || `Error to publish draft item`, 'error');
            }
          });
      }
    );
  };
}

const certificationTestRegisterItemListService = new CertificationTestRegisterItemListService();

export default certificationTestRegisterItemListService;
